import { useEffect, useRef, useState } from "react";
import { useCurrentRefinements, useRefinementList } from "react-instantsearch";
import Srcset from "../common/Srcset";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import CustomCurrentRefinements from "./CustomRefinementTitle";
import CustomNumericMenu from "./CustomNumericMenu"
import CustomRefinementWithSearchable from "./CustomRefinementWithSearchable";
import { attributeTitles, renderFilterLabel, filterClickHandler, getSelectedFiltersCount, handleDropdownOnFilterCategory, renderFilterByLevelType, priceRangeCollection, checkFilterHierarchy, disableFirstUl, sortSizesFilter, renderEngraveFilterLabel } from "./filters-utils"
import { useDispatch } from "react-redux";
import { setFiltersSelectedFlag } from "@/redux/actions/filtersAction";
import { PLPFiltersTracking } from "../common/Tracking";
import { colorCode } from "@/utils/constants";
import { collectionPath } from "./collection-utils";
import EngraveCustomRefinementList from "./EngraveCustomRefinementList";

const CustomRefinementList = (props) => {
  const dispatch = useDispatch();
  // Create a copy of the attributeTitles object and add your custom attribute
  const updatedAttributeTitles = {
    ...attributeTitles,
    "named_tags.Availability": "Availability"
  };
  // Find the index of "named_tags.categories.lvl2" in the updatedAttributeTitles
  const index = Object.keys(updatedAttributeTitles).indexOf("named_tags.categories.lvl2");

  // Check if the index is found, and if so, add your custom attribute after it
  if (index !== -1) {
    const keys = Object.keys(updatedAttributeTitles);
    keys.splice(index + 1, 0, "named_tags.Availability");
    keys.forEach((key) => {
      attributeTitles[key] = updatedAttributeTitles[key];
    });
  }

  const [appliedFilterCount, setAppliedFilterCount] = useState(null);
  let initialRefinement = props.initialRefinement;

  // check if the server path is "/new-arrivals"
  let isNewArrivalPage = props.serverPath.split("/")[1] === collectionPath[2] ? true : false;

  const ulRef = useRef(null);
  let level = ulRef.current?.dataset?.level;

  /**
   * gets all the items having the attributes using useRefinement hook, and showing number of items limit
   * We are showing default 20 facets per filter, but for size filter we have more than 20 so taking it from props
   */
  let { items, refine } = useRefinementList({ ...props, limit: (props.attribute === "meta.custom.us_size") ? props.limit : 20 });

  //available category list
  var catList = [];
  if (props.attribute === Object.keys(attributeTitles)[1]) {
    items.map(item => {
      catList.push(item);
    })
  }

  //to show subcategory when subcategory list is not empty
  var subCatList = [];
  if (props.attribute === Object.keys(attributeTitles)[2]) {
    items.map(item => {
      subCatList.push(item);
    })
  }


  useEffect(() => {
    setAppliedFilterCount(getSelectedFiltersCount(ulRef));
  });

  // get the applied filters details
  let { items: appliedFilters, refine: clearExistingRefinement } = useCurrentRefinements(props);
  var catHasValidOption = [];
  var subCatHasValidOption = [];
  // array of applied category
  const filteredData = appliedFilters.filter(item => item.attribute == Object.keys(attributeTitles)[1]);

  if(!props.serverRender){
      // array of applied type
  const filteredDataType = appliedFilters.filter(item => item.attribute == Object.keys(attributeTitles)[0]);

  //checks if selected level 0 filters has subcategory level 1 filters
  if (filteredDataType) {
    filteredDataType[0]?.refinements.map(item => {
      catList.map(cat => {
        // if (cat.value.toUpperCase().includes(item.value.toUpperCase())) {
        catHasValidOption.push(item.value);
        // }
      })
    })
  }
  //checks if selected level 1 filters has subcategory level 2 filters
  if (filteredData) {
    filteredData[0]?.refinements.map(item => {
      subCatList.map(subcat => {
        if (subcat.value.toUpperCase().includes(item.value.toUpperCase())) {
          subCatHasValidOption.push(item.value);
        }
      })
    })
  }
}

  // checks if the level-1 filters exist in the appliedFilters to render level-2 filter section
  const appliedFiltersContainLvl1Label = () => appliedFilters.find((elem) => elem.label === Object.keys(attributeTitles)[1]) ? true : false

  //get current window url
  //OS-5192 gender conscious filter removed
  const url = typeof window != "undefined" && window.location.href;
  const filterType = (attribute) => {
    switch (attribute) {
      case "named_tags.categories.lvl0":
        return "type";
      case "named_tags.categories.lvl1":
        return "Cat";
      case "named_tags.categories.lvl2":
        return "Subcat";
      case "meta.color.base_color":
        return "Color";
      case "meta.custom.us_size":
        return "Size";
      case "named_tags.Material":
        return "Material";
      case "named_tags.Stone":
        return "Stone";
      case "named_tags.Availability":
        return "Availability";
      // case "named_tags.Vendor":
      //     return "Vendor";  
      default:
        return attribute;
    }
  }

  // Open next filter for cat 0 and cat 1 
  const openNextTile = (event) => {
    const parent = event.currentTarget.closest('.filter_main_item');
    const containingParent = event.currentTarget.parentNode // UL of the selected LI tag
    if (containingParent.classList.contains('cat-lvl1')) {
      // get the count of checked items inside the container UL
      const totalChecked = Array.from(containingParent.querySelectorAll('input[type="checkbox"]:checked'))
      // get the checkbox which is currently clicked
      const currentlyClickedElement = event.target.previousElementSibling

      if (totalChecked.length === 1 && totalChecked[0] === currentlyClickedElement) {
        return
      }
      else {
        parent.querySelector('.plp-filter-header').click();
      }
    }
    if (!containingParent.classList.contains('cat-lvl1')) {
      parent.querySelector('.plp-filter-header').click();
    }

    if (!parent) {
      return;
    }
    let nextNode = parent.nextSibling;
    if (!nextNode) {
      return;
    }
    if (!nextNode.classList.contains('active') && !nextNode.classList.contains('non-cat')) {
      nextNode.querySelector('.plp-filter-header').click();
    }
  }

  const getTypeByFilterAttribute = () => {
    if (props.attribute === Object.keys(attributeTitles)[0] && isNewArrivalPage) {
      return 'type'
    }
    else {
      return 'checkbox'
    }
  }
  
  // render default filter sections i.e. other than pricing & designers
  const renderDefaultFilterSection = () => {
    return items.map((singleElement, index) => {
      let disableThis = false;
      let defaultRefined = []
      if (initialRefinement) {
        defaultRefined = initialRefinement[props.attribute];
      }
      if (defaultRefined && defaultRefined.length > 0) {
        if (defaultRefined && singleElement.value === defaultRefined[0]) {
          disableThis = true;
          if (props.attribute === "named_tags.categories.lvl0") {
            if (ulRef.current) {
              disableFirstUl(ulRef.current);
            }
          }
        }
      }

      //multiple category selection
      let hasSubcat = false;
      filteredData[0]?.refinements.map((levelOne) => {
        if (singleElement.value.toUpperCase().includes(levelOne.value.toUpperCase())) {
          hasSubcat = true;
        }
      })
      //OS-5291 below is done to rename MORE LETTERS AVAILABLE to Letters available
      let label = props.attribute === "named_tags.Tag1" ? renderEngraveFilterLabel(singleElement) : singleElement.value;
      return (
        props.attribute === "named_tags.categories.lvl2" ? (
          hasSubcat && (
            <li
              key={index}
              onClick={() => {
                filterClickHandler(singleElement, refine, props.serverRender);
                dispatch(setFiltersSelectedFlag(true));
                PLPFiltersTracking(filterType(props.attribute), label, singleElement.isRefined);
              }}
            >
              <div className="custom-checkbox">
                {/* if items are of level0 then checkbox should disabled */}
                {renderFilterByLevelType(props.attribute, singleElement, level, disableThis)}
                <label><span>{renderFilterLabel(props.attribute, singleElement)}</span></label>
              </div>
            </li>
          )
        )
          :
          <li
            key={index}
            onClick={(e) => {
              if (disableThis) return;
              if (props.attribute === Object.keys(attributeTitles)[0] || props.attribute === Object.keys(attributeTitles)[1]) {
                openNextTile(e);
              }
              filterClickHandler(singleElement, refine, props.serverRender, isNewArrivalPage, appliedFilters, clearExistingRefinement, props.attribute);
              dispatch(setFiltersSelectedFlag(true));
              PLPFiltersTracking(filterType(props.attribute), label, singleElement.isRefined);
            }}
          >
            <div className="custom-checkbox">
              {/* if items are of level0 then checkbox should disabled */}
              {renderFilterByLevelType(props.attribute, singleElement, getTypeByFilterAttribute(), disableThis, isNewArrivalPage)}
              <label>
                {filterType(props.attribute) == 'Color' ? (
                  <div className='color-label-outter' >
                    <div className={`${styles.color_label_inner}`} style={{ backgroundColor: colorCode.data[renderFilterLabel(props.attribute, singleElement)] }}></div>
                  </div>
                ) : (
                  ''
                )}
                <span>{props.attribute === "named_tags.Tag1" ? label: renderFilterLabel(props.attribute, singleElement)}</span>
              </label>
            </div>
          </li>
      );
    })

  }

  // render filter section by its attribute
  //OS-5291 key changed to attribute name as maintaining with number was difficult to achieve the hide show of filters
  const renderFilterSectionByFilterAttribute = (filterAttribute, filterType) => {
    switch (filterAttribute) {
      case 'price': // price section
        return (
          <CustomNumericMenu
            attribute={props.attribute}
            items={priceRangeCollection}
            renderFilterByLevelType={renderFilterByLevelType}
            renderFilterLabel={renderFilterLabel}
            level={level}
            filterType={filterType}
            serverPath={props.serverPath}
            indexName={props.indexName}
          />
        );
      case 'vendor': // designer section
        return (
          <CustomRefinementWithSearchable
            searchable={true}
            searchablePlaceholder="Search Designers..."
            attribute={props.attribute}
            sortBy={["name:asc", "isRefined:asc"]}
            showMore={false} // keep it false to hide the show more button
            filterType={filterType}
            serverRender={props.serverRender}
          />
        )
      case 'named_tags.categories.lvl2': // lvl-2 filter section
        return appliedFiltersContainLvl1Label() ? renderDefaultFilterSection() : <></>
      default: // rest other sections
        return (
          <>
            {renderDefaultFilterSection(filterType)}
          </>
        )
    }
  }

  const renderCrossIcon = () => (
    <span
      className={styles.filter_action_plus}
    >
      <Srcset
        height="15"
        width="15"
        alt="Account"
        requirePath={true}
        svgFile={true}
        src={"images/Icons/Cross/Large.svg"}
      />
    </span>
  )

  const renderFilterHeaderActions = (filterAttribute) => {
    switch (filterAttribute) {
      case Object.keys(attributeTitles)[0]: // category attribute
        return (
          <>
            <span className={`${styles.filter_action_txt} filter_count x-small`} >
              <CustomCurrentRefinements attribute={Object.keys(attributeTitles)[0]} />
            </span>
            {renderCrossIcon()}
          </>
        )
      case Object.keys(attributeTitles)[2]: // category level-2
        return (
          <>
            {appliedFiltersContainLvl1Label() ? (
              <>
                {
                  appliedFilterCount ? (
                    <>
                      <span className={`${styles.filter_action_txt} text-10 filter_count`}>
                        {appliedFilterCount}
                      </span>
                      {renderCrossIcon()}
                    </>
                  ) : (
                    <>
                      {renderCrossIcon()}
                    </>
                  )
                }
              </>
            ) : (<></>)}

          </>
        )
      default: // rest other sections
        return (
          <>
            {
              appliedFilterCount ? (
                <>
                  <span className={`${styles.filter_action_txt} text-10 filter_count`}>
                    {appliedFilterCount}
                  </span>
                  {renderCrossIcon()}
                </>
              ) : (
                <>
                  {renderCrossIcon()}
                </>
              )
            }
          </>
        )
    }
  }

  const getDisplayStyle = () => {
    switch (props.attribute) {
      case Object.keys(attributeTitles)[1]:
        if (appliedFilters.find((elem) => elem.attribute === Object.keys(attributeTitles)[0])) {
          return 'block';
        }
        return 'none';
      case Object.keys(attributeTitles)[2]:
        if (appliedFilters.find((elem) => elem.attribute === Object.keys(attributeTitles)[1])) {
          return 'block';
        }
        return 'none';
      default:
        return 'none'
    }
  }
  return (
    <>
    {
    //along with items.length check availability check is needed as under availability we have combines availability and tag_curated options
    // for the filter display to work correctly if options are not there then we have hided it manually
    }
      {items?.length || props.attribute == 'named_tags.Availability' ?
        (
          <>
          {/* OS-5291 below classes are defined to achieve hide show of filters */}
            <div className={`${getDisplayStyle() == 'block' ? 'active' : ''} ${styles.filter_item} 
            ${props.attribute === Object.keys(attributeTitles)[1] && !catHasValidOption.length && "d-none"} 
            ${props.attribute === Object.keys(attributeTitles)[2] && !subCatHasValidOption.length && "d-none"}  
            ${props.attribute === Object.keys(attributeTitles)[2] && !(appliedFiltersContainLvl1Label()) ? 'subCatEmpty' : ' '} 
            ${props.attribute.includes('categories') ? null : 'non-cat'}
            ${props.attribute == 'named_tags.Availability' ? 'availability-filter hide_filter' : ''}
            ${props.attribute == 'named_tags.Material' ? 'material-filter hide_filter' : ''}
            ${props.attribute == 'named_tags.Stone' ? 'stone-filter hide_filter' : ''}
            ${props.attribute == 'tags' ? 'personalization-filter hide_filter' : ''}
            ${props.attribute == 'named_tags.Style > Sleeves' ? 'sleeves-filter hide_filter' : ''}
            ${props.attribute == 'named_tags.Style > Heel Height' ? 'heel-filter hide_filter' : ''}
            ${props.attribute == 'vendor' && props.serverPath.includes('designer') ? 'd-none' : ''}
            filter_item filter_nav_items filter_main_item collapse`}>
              {!props.serverRender && <div className={`${styles.filter_item_head} auto-${attributeTitles[props.attribute]} plp-filter-header`}
                onClick={(e) => {
                  handleDropdownOnFilterCategory(e)
                }}>
                <div className={`${styles.filter_item_title} normal-sm normal-md small-xs`}>
                  {attributeTitles[props.attribute]}
                </div>
                <div className={`${styles.filter_item_action}`}>
                  {renderFilterHeaderActions(props.attribute)}
                </div>

              </div>}
              <div
                className={`${styles.filter_item_body} filter_body`}
                style={{ display: getDisplayStyle() }}>
                <ul
                  className={`filter_item_list ${filterType(props.attribute) == 'Color' ? 'color-ul' : ''} cat-${props.attribute.replace('named_tags.categories.', '')}`} data-level={`${level}`} ref={ulRef}
                >
                  {props.attribute!='tags' && renderFilterSectionByFilterAttribute(props.attribute, filterType(props.attribute))}
                 {/* OS-5291 we are combining mto filter options under Availability filter */}
                 {props.attribute=='named_tags.Availability' && <EngraveCustomRefinementList key={props.index} attribute="named_tags.Tag_curated" sortBy={["name:asc"]} initialRefinement={props.initialRefinement} serverPath={props.serverPath} indexName={props.indexName} serverRender={props.serverRender} />}
                {/* OS-5291 we are combining engraving filter options under personalization filter */}
                 {props.attribute=='tags' && <EngraveCustomRefinementList key={props.index} attribute="named_tags.Tag1" sortBy={["name:asc"]} initialRefinement={props.initialRefinement} serverPath={props.serverPath} indexName={props.indexName} serverRender={props.serverRender}/>}
                 {props.attribute=='tags' && <EngraveCustomRefinementList key={props.index} attribute="named_tags.Tag2" sortBy={["name:asc"]} initialRefinement={props.initialRefinement} serverPath={props.serverPath} indexName={props.indexName} serverRender={props.serverRender} />}

                </ul>
              </div>
            </div>
          </>
        )
        :
        (
          <></>
        )
      }
    </>
  );
};
export default CustomRefinementList;
